import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { useMsal } from "@azure/msal-react";

interface PermissionsContextType {
  roles: string[];
}

// Define the prop type for PermissionsProvider to include children
interface PermissionsProviderProps {
  children: ReactNode;
}

const PermissionsContext = createContext<PermissionsContextType | undefined>(undefined);

export const PermissionsProvider: React.FC<PermissionsProviderProps> = ({ children }) => {
  const { accounts } = useMsal();
  const [roles, setRoles] = useState<string[]>([]);

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      // Extract roles from ID token claims if present
      const idTokenClaims = accounts[0]?.idTokenClaims || {};
      
      // If roles are stored in `roles` claim
      if (idTokenClaims.roles) {
        setRoles(idTokenClaims.roles as string[]);
      }
      // If roles are stored in a custom claim like `groups`
      else if (idTokenClaims.groups) {
        setRoles(idTokenClaims.groups as string[]);
      }
    }
  }, [accounts]);

  return (
    <PermissionsContext.Provider value={{ roles }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = (): PermissionsContextType => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissions must be used within a PermissionsProvider');
  }
  return context;
};
